<template>
  <div class="medicine-order-details-watsons-pickup">
    <text-string class="m-b-20"
                 label-id="txt337"
                 :props="{'strings': [selectedWatson.branchName, validityDate]}"/>

    <div class="smd-form__row m-b-30 justify-content-center">
      <coupon-countdown-timer :start-time="startTimeString"
                              :end-time="endTimeString"
                              large
                              :trans="$options.transConfig"/>
    </div>

    <div class="medicine-order-details-watsons-pickup__body smd-panel" ref="printMe">
      <div class="smd-form__row logos">
        <div class="smd-form__col">
          <img src="~@/assets/images/nowserving.png"
               class="image"
               alt="NowServing Logo">
        </div>
        <div class="smd-form__col">
          <img src="~@/assets/images/img001.png"
               class="image"
               alt="By SeriousMD Logo">
        </div>
      </div>
      <div class="smd-form__row justify-content-center">
        <smd-coupon btn-label="Press to get coupon"
                    class="pickup-finish__coupon"
                    small
                    :item="coupon"
                    :title="coupon.shortname"
                    :description="coupon.shortname"
                    :image="couponImage"/>
      </div>
      <div class="smd-form__row justify-content-center">
        <p class="Body5">Watsons {{ selectedWatson.branchName }}</p>
      </div>
      <div class="smd-form__row">
        <div class="smd-form__col">
          <text-string class="reset-m" label-id="txt046"/>
          <p class="Title1">{{ patientName }}</p>
        </div>
      </div>
      <div class="divider m-b-20"></div>
      <div class="crimson m-b-10">
        <text-string class="m-b-5" label-id="txt291"/>
        <text-string label-id="txt335"/>
      </div>
      <div class="smd-form__row justify-content-center">
        <redemption-code :code="redemptionCode"/>
      </div>
      <div class="smd-form__row justify-content-center"
           id="js-save-screenshot-btn">
        <smd-btn section="4"
                 variant="blue-enabled"
                 @click="saveScreenshot">
          <text-string label-id="txt223"/>
        </smd-btn>
      </div>
    </div>

    <div class="flex-row-center-xy-spaced m-b-30 m-t-30">
      <smd-btn section="4"
               variant="unselected"
               @click="cancelOrder">
        <text-string label-id="txt267"/>
      </smd-btn>
      <smd-btn section="4"
               variant="blue-enabled"
               @click="reportIssue">
        <text-string label-id="txt219"/>
      </smd-btn>
    </div>

    <div class="divider--dotted m-b-20"></div>

    <div v-if="serviceOrder.prescriptions.length" class="added-prescriptions m-b-20">
      <text-string label-id="txt336" class="m-b-15"/>

      <div v-for="(prescription, prescriptionIndex) in serviceOrder.prescriptions"
           :key="prescriptionIndex">
        <prescription-card v-if="prescription.token"
                           :prescription="prescription"
                           class="m-b-15">
          <div v-if="prescription.remarks && prescription.remarks !== ''" class="remarks">
            <text-string label-id="txt058" class="m-t-10"/>
            <p class="Body1">{{ prescription.remarks }}</p>
          </div>
        </prescription-card>

        <attached-file-card v-if="!prescription.token"
                            class="m-b-15"
                            :prescription="prescription"
                            :orderid="serviceOrder.orderid">
          <div v-if="prescription.remarks && prescription.remarks !== ''" class="remarks">
            <text-string label-id="txt058" class="m-t-10"/>
            <p class="Body1">{{ prescription.remarks }}</p>
          </div>
        </attached-file-card>
      </div>
    </div>
  </div>
</template>

<script>
  import RedemptionCode from '@/components/redemption-code';
  import WatsonsSmallLogo from '@/assets/images/pharmacies/img003.png';
  import MedicineOrderDetailsWatsonsMixin from '@/mixins/medicine-order-details-watsons-finished-mixin';
  import {getCouponLogo} from '@/reference/coupon';

  export default {
    name: 'medicine-order-details-watsons-pickup',
    mixins: [
      MedicineOrderDetailsWatsonsMixin,
    ],
    components: {
      RedemptionCode,
    },
    computed: {
      validityDate() {
        return `<span class="crimson">until ${this.endTime.format('MMM D, YYYY')}</span>`;
      },
      couponImage() {
        return getCouponLogo(this.coupon) || this.$options.WatsonsSmallLogo;
      },
    },
    methods: {
      async saveScreenshot() {
        const el = this.$refs.printMe;
        const a = document.createElement('a');
        const saveScreenshot = document.getElementById('js-save-screenshot-btn');
        const options = {
          type: 'dataURL',
          allowTaint: false,
          useCORS: true,
          logging: false,
        }
        saveScreenshot.classList.add('hidden');

        try {
          this.screenshotOutput = await this.$html2canvas(el, options);

          saveScreenshot.classList.remove('hidden');

          a.href = this.screenshotOutput
          a.download = `${this.coupon.description}.jpg`;
          a.click();
        } catch (error) {
          saveScreenshot.classList.remove('hidden');
          this.showToast({
            text: 'Failed to generate screenshot. Please try again later.',
            theme: 'danger',
          });
        }
      },
    },
    WatsonsSmallLogo,
  }
</script>

<style lang="scss">
  .medicine-order-details-watsons-pickup {
    padding: 16px 20px;

    @include responsive(desktop) {
      @include border-radius();
      @include box-shadow();
      background: color(white);
      padding: space(xxl);
      margin: 40px 20px 40px 40px;
      max-width: 900px;
    }

    @include responsive('max-width: 1023px') {
      margin-left: 0 !important;
    }
    @include responsive('min-width: 1800px') {
      margin: 40px auto 40px;
      width: 100%;
    }

    .logos {
      width: 90%;
      max-width: 337px;
      margin: 0 auto space(l) auto;

      img {
        width: 100%;
      }
    }
  }

  .medicine-order-details-watsons-pickup__body {
    @include responsive(desktop) {
      padding: space(xl) space(xxl);
    }

  }
</style>
